import React from "react";
import StarIcon from "./StarIcon";

interface WatchlistIconProps {
  height?: string;
  width?: string;
  color?: string;
  watch?: boolean;
}

const WatchlistIcon = (props: WatchlistIconProps) => {
  return (
    <StarIcon
      width={props.width}
      height={props.height}
      watch={props.watch ? true : false}
      color={props.color}
    />
  );
};

export default WatchlistIcon;
